// import axios from "axios";

// const api = axios.create({
//   baseURL: process.env.REACT_APP_BASE_URL_DEV,
// });

// api.setToken = (token) => {
//   if (token) {
//     api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
//   } else {
//     delete api.defaults.headers.common["Authorization"];
//   }
// };

// api.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     const currentPath = window.location.pathname;
//     let redirectPath = null;

//     if (error.response) {
//       const status = error.response.status;

//       if (status === 401) {
//         sessionStorage.removeItem("jwt");
//         localStorage.removeItem("jwt");

//         if (currentPath.startsWith("/gfb-admin/login")) {
//           redirectPath = `/gfb-admin/error/${status}`;
//         } else {
//           redirectPath = "/gfb-admin/login";
//         }
//       } else if (status === 409 || status === 400 || status === 203  || status === 500) {
        
//         return Promise.reject(error);
//       } else {
//         // Other status codes
//         if (currentPath.startsWith("/gfb-admin/login")) {
//           redirectPath = `/gfb-admin/error/${status}`;
//         } else {
//           redirectPath = "/gfb-admin/login";
//         }
//       }
//     } else if (error.request) {
//       if (currentPath.startsWith("/gfb-admin/login")) {
//         redirectPath = "/gfb-admin/error/network";
//       } else {
//         redirectPath = "/gfb-admin/login";
//       }
//     } else {
//       if (currentPath.startsWith("/gfb-admin/login")) {
//         redirectPath = "/gfb-admin/error/unexpected";
//       } else {
//         redirectPath = "/gfb-admin/login";
//       }
//     }

//     if (redirectPath) {
//       window.location.href = redirectPath;
//     }

//     return Promise.reject(error);
//   }
// );


// export default api;
import axios from "axios";
import { CookieIcon } from "lucide-react";
import Cookies from "js-cookie";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_DEV,
  withCredentials: true,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN"
});
 
api.setToken = (token) => {
  if (token) {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete api.defaults.headers.common["Authorization"];
  }
};
api.interceptors.request.use((config) => {
const xsrfToken = Cookies.get("XSRF-TOKEN");
//  const xsrfToken= Cookies.get("XSRF-TOKEN");
 if(xsrfToken){
  config.headers["X-XSRF-TOKEN"] = xsrfToken;
 }

 
  return config;


});
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const currentPath = window.location.pathname;
    let redirectPath = null;
 
    if (error.response) {
      const status = error.response.status;
 
      if (status === 401) {
        sessionStorage.removeItem("jwt");
        localStorage.removeItem("jwt");
 
        if (currentPath.startsWith("/gfb-admin/login")) {
          redirectPath = `/gfb-admin/error/${status}`;
        } else {
          redirectPath = "/gfb-admin/login";
        }
      } else if (status === 409 || status === 400 || status === 203 || status === 404 || status == 500 || status === 429) {
        return Promise.reject(error);
      } else {
        // Other status codes
        sessionStorage.removeItem("jwt");
        localStorage.removeItem("jwt");
 
        if (currentPath.startsWith("/gfb-admin/login")) {
          redirectPath = `/gfb-admin/error/${status}`;
        } else {
          redirectPath = "/gfb-admin/login";
        }
      }
    } else if (error.request) {
      sessionStorage.removeItem("jwt");
      localStorage.removeItem("jwt");
 
      if (currentPath.startsWith("/gfb-admin/login")) {
        redirectPath = "/gfb-admin/error/network";
      } else {
        redirectPath = "/gfb-admin/login";
      }
    } else {
      sessionStorage.removeItem("jwt");
      localStorage.removeItem("jwt");
 
      if (currentPath.startsWith("/gfb-admin/login")) {
        redirectPath = "/gfb-admin/error/unexpected";
      } else {
        redirectPath = "/gfb-admin/login";
      }
    }
 
    if (redirectPath) {
      window.location.href = redirectPath;
    }
 
    return Promise.reject(error);
  }
);
 
 
export default api;
 
 